function toggleFilter(event) {
    const target = event.currentTarget
    const content = target.nextElementSibling
    
    content.classList.toggle('open')
}

function applyFilter(event) {
    const target = event.currentTarget
    
    if(new URL(target.value)) {
        window.location.href = target.value
    }
}
(function($) {
  
    // Menu
    function menuToggle(e) {
        $('.mobile-menu-button').toggleClass('open');
        $('.main-navbar').toggleClass('open');
        $('body').toggleClass('no-scroll');
    }
    $('.mobile-menu-button').on('click', menuToggle);
    
    function submenuToggle(e) {
      e.preventDefault()
      
      if ($(this).attr('href') != "#" && screen.width > 1200) {  
        window.location.replace($(this).attr('href'));
      }
      
      $(this).parent().toggleClass('active');
      
      let submenu = $(this).next('.menu');
      
      if ($(this).parent().hasClass('active') && submenu.length) {
        submenu.height(submenu.prop("scrollHeight"));
      } else {
        submenu.height(0)
      }
    }
    $('.main-navbar .menu-item-has-children > a').on('click tap', submenuToggle);
    
    function closeMenuOnClick(event) {
      if(!$(event.target).parent().hasClass('menu-item-has-children')) {
        menuToggle();
      }
    }
    $('.main-navbar a').on('click', function(e) {
      if(window.matchMedia('(max-width: 1200px)').matches) {
        closeMenuOnClick(e)
        return
      }
    })
    $('footer a[href="#"]').on('click', function(e) {
      e.preventDefault();
    });
  
})(jQuery);
(function($) {
    
    // Slider de imagens
    const  galeriaSlider = $('main.single-produtos .product-content .slider-container')
    if( galeriaSlider.length) {
         galeriaSlider.each(function () {
            const container = $(this)
            const slider = container.find('.slider-wrapper')
            const prevArrow = container.find('.prev')
            const nextArrow = container.find('.next')
			
            slider.slick({
                accessibility: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true,
                variableWidth: false,
                prevArrow: prevArrow,
                nextArrow: nextArrow,
                responsive: [
                    {
                        breakpoint: 576,
                        settings: {
                            variableWidth: true,
                            centerMode: true,
                            arrows: false,
                            dots: true,
                            appendDots: container,
                        }
                    }
                ]
            })
        })
    }
    
    // Slider de produtos relacionados
    const  relacionadosSlider = $('main.single-produtos .related .slider-container')
    if( relacionadosSlider.length) {
         relacionadosSlider.each(function () {
            const container = $(this)
            const slider = container.find('.slider-wrapper')
            const prevArrow = container.find('.prev')
            const nextArrow = container.find('.next')
			
            slider.slick({
                accessibility: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true,
                variableWidth: false,
                prevArrow: prevArrow,
                nextArrow: nextArrow,
                responsive: [
                    {
                        breakpoint: 993,
                        settings: { 
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: { 
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: true,
                            centerMode: true,
                            arrows: false,
                            dots: true,
                            appendDots: container
                        }
                    }
                ]
            })
        })
    }
    
})(jQuery);
(function($) {
    
    // Slider de imagens
    const etapasSlider = $('.template-sobre-nos .slider .slider-container')
    if(etapasSlider.length) {
        etapasSlider.each(function () {
            const container = $(this)
            const slider = container.find('.slider-wrapper')
            const prevArrow = container.find('.prev')
            const nextArrow = container.find('.next')
			
            slider.slick({
                accessibility: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: false,
                arrows: true,
                variableWidth: false,
                prevArrow: prevArrow,
                nextArrow: nextArrow,
                responsive: [
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: true,
                            centerMode: true,
                            arrows: false,
                            dots: true,
                            appendDots: container
                        }
                    }
                ]
            })
        })
    }
    
})(jQuery);
(function($) {
    
    function showWhatsAppButton() {
		const whatsAppButton = document.querySelector('.whatsapp-flutuante')
		
		if(whatsAppButton) {
			whatsAppButton.classList.remove('hidden-button')
		}
	}
	
	const lgpdBar = document.querySelector('.lgpd-container')
	
	if(!lgpdBar) {
		showWhatsAppButton()
	} else {
		window.addEventListener('DestroyLGPD', showWhatsAppButton)
	}
    
})(jQuery);
(function($) {
    
    // CF7 events
	const cf7 = document.querySelectorAll('.wpcf7 form')
	
	if(cf7) {
		cf7.forEach(form => {
			form.addEventListener('submit', function() {
				const button = this.querySelector('button[type=submit]')
				
				button.setAttribute('disabled', true)
				button.classList.add('loading')
			})
		
			form.addEventListener('wpcf7submit', function() {
				const button = this.querySelector('button[type=submit]')
				
				button.removeAttribute('disabled')
				button.classList.remove('loading')
			})
		})
	}
	
    // Mask phone input
    let phoneMaskFunction = function(val) {
    	return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    }
    
    $('input[type="tel"]').mask(phoneMaskFunction, {
    	onKeyPress: function(val, e, field, options) {
    		field.mask(phoneMaskFunction.apply({}, arguments), options);
    	}
    });
    
    // Mask date inputs
    $('input.custom-date').mask('00/00/0000')
    
})(jQuery);